// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ykGpr","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__kd3uN"};